import { httpRequest } from "../../http";

// Campaign-level publish control (MPN-1364). Deliberately separate from the network view:
// that one dispatches a job and polls every network's API, while all of this is local state
// and has to be usable the moment the page opens.

export interface CampaignPublishControl {
  launch_id: number;
  launch_name: string;
  ad_group_count: number;
  is_ready_to_publish: boolean;
  last_published: string | null;
  /** The billing boundary (MPN-1498). Stamped by the first publish that actually went
      live and then frozen — there is deliberately no write path for it, so this is
      display-only and must never be rendered as an input. Null = never published. */
  go_live_date: string | null;
  /** "ready" | "blocked" | "held" — the sentence is for people, this is for styling. */
  status: string;
  status_reason: string;
  history_count: number;
}

export interface NetworkAttempt {
  network: string | null;
  status: string;
  is_successful: boolean;
  error?: string | null;
}

/** One event on a campaign's timeline: a publish attempt, or a readiness toggle.
    `kind` says which — the fields that do not apply are null rather than invented. */
export interface HistoryEntry {
  kind: "publish" | "readiness";
  at: string;
  user_name: string | null;

  // publish
  attempt_id?: number | null;
  is_successful?: boolean | null;
  published_paused?: boolean | null;
  networks?: NetworkAttempt[];

  // readiness
  is_ready_to_publish?: boolean | null;
}

const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements`;

export class CommandGetPublishControl {
  async run(engagementId: number): Promise<CampaignPublishControl[]> {
    return httpRequest<CampaignPublishControl[]>(`${base}/${engagementId}/publish-control/`);
  }
}

export class CommandSetLaunchReady {
  async run(launchId: number, isReady: boolean): Promise<CampaignPublishControl> {
    return httpRequest<CampaignPublishControl>(`${base}/launches/${launchId}/ready/`, {
      method: "PATCH",
      body: JSON.stringify({ is_ready_to_publish: isReady }),
    });
  }
}

export class CommandGetPublishHistory {
  async run(launchId: number): Promise<HistoryEntry[]> {
    return httpRequest<HistoryEntry[]>(`${base}/launches/${launchId}/publish-history/`);
  }
}
